import { render, staticRenderFns } from "./PermissionsListView.vue?vue&type=template&id=40e231fa&scoped=true&"
import script from "./PermissionsListView.vue?vue&type=script&lang=js&"
export * from "./PermissionsListView.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsListView.vue?vue&type=style&index=0&id=40e231fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e231fa",
  null
  
)

export default component.exports